export default __webpack_public_path__ + "static/media/tq.79bf7787.gif";